import { render, staticRenderFns } from "./FavouriteCell.vue?vue&type=template&id=295bb574&scoped=true"
import script from "./FavouriteCell.vue?vue&type=script&lang=js"
export * from "./FavouriteCell.vue?vue&type=script&lang=js"
import style0 from "./FavouriteCell.vue?vue&type=style&index=0&id=295bb574&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295bb574",
  null
  
)

export default component.exports